import { gql } from '@apollo/client'

export const resetPasswordQuery = gql`
  mutation resetPassword($input: ResetPasswordArgs!) {
    resetPassword(input: $input)
  }
`
